import { useState, useEffect, useRef } from "react";
import { useDispatch } from "react-redux";
import { Link } from "react-router-dom";
import { openRatingPopup, openMeetingEdit, openMeetingCancel } from "../../redux/modules/meeting";

const TableRowMob = ({columns, data, eventTypeId}) => {
    const dispatch = useDispatch();
    const rootEl = useRef(null);
    const [menu, setMenu] = useState(false);
    const [open, setOpen] = useState(false);

    useEffect(() => {
        const onClick = e => rootEl.current ? (rootEl.current.contains(e.target) || setMenu(false)) : ''
        document.addEventListener('click', onClick);
        return () => document.removeEventListener('click', onClick);
      }, []);

    const actions = () => {

        return (
            <div className={menu ? "actions open" : "actions"} ref={rootEl}>
                <div className="actions__icon" onClick={() => setMenu(!menu)}>
                    <div></div>
                    <div></div>
                    <div></div>                    
                </div>
                <div className="actions__menu">
                    <div className="actions__close" onClick={() => setMenu(false)}></div>
                    <div className="actions__menu__item"><Link to="/change-access" state={{ id: data.id, fio: data.fio, group: {value: data.group, label: data.group == 'brocker' ? 'Брокер' : 'Администратор' } }}>Изменить права доступа</Link></div>
                    <div className="actions__menu__item">
                        <Link to={data.blacklist ? "/delete-blacklist" : "/add-blacklist"} state={{ id: data.id, fio: data.fio }}>{data.blacklist ? 'Удалить из черного списка' : 'Добавить в черный список'}</Link>
                    </div>
                    <div className="actions__menu__item"><Link to="/delete-agent" state={{ id: data.id, fio: data.fio }}>Удалить</Link></div>
                </div>
            </div>
        )
    }

    
    const action = () => {

        return (
            <div className={menu ? "actions open" : "actions"} ref={rootEl}>
                <div className="actions__icon" onClick={() => setMenu(!menu)}>
                    <div></div>
                    <div></div>
                    <div></div>                    
                </div>
                <div className="actions__menu">
                    <div className="actions__close" onClick={() => setMenu(false)}></div>
                    {(data['status'] === 'Запланирована' || data['status'] === 'Запланирован') && (
                        <>
                            <div className="actions__menu__item"><Link to={eventTypeId == 1 ? '/edit-meeting' : '/edit-broker-tour'} state={{ back: window.location.pathname, hash: document.querySelector('.tabs__item[data-active="true"]') ? ('#' + document.querySelector('.tabs__item[data-active="true"]').getAttribute('id')) : window.location.hash }} onClick={handleEdit}>Редактировать</Link></div>
                            <div className="actions__menu__item"><Link to={eventTypeId == 1 ? '/cancel-meeting' : '/cancel-broker-tour'} state={{ back: window.location.pathname, hash: document.querySelector('.tabs__item[data-active="true"]') ? ('#' + document.querySelector('.tabs__item[data-active="true"]').getAttribute('id')) : window.location.hash }} onClick={handleCancel}>Отменить</Link></div>
                        </>
                    )}
                    {(data['status'] === 'Выполнена' || data['status'] === 'Выполнен') && data['rate'] == undefined && <div className="actions__menu__item"><Link to="" onClick={() => dispatch(openRatingPopup({id: data['id']}))}>Оценить</Link></div>}                    
                </div>
            </div>
        )
    }

    const handleEdit = () => {
        dispatch(
            openMeetingEdit({
                ...data,
                eventTypeId: eventTypeId
            })
        )
    }

    const handleCancel = () => {
        dispatch(openMeetingCancel({
            ...data,
            eventTypeId: eventTypeId
        }))
    }
    
    return (
        <div className={open ? "table__tr open" : "table__tr"} onClick={() => !open && setOpen(!open)} key={data.id}>
            {columns.map(({ value, label }) => {

                let val;
                if(data[value] !== 'undefined') {
                    if(value === 'project') {
                        val = <>{data['project']}<div>{data['type']}</div></>
                    } 
                    else if(value === 'type') {
                        return
                    }
                    else if(value === 'group') {
                        val = data[value] === 'brocker' ? 'Брокер' : 'Администратор'
                    } 
                    else if(value === 'date' || value === 'dateAdd' || value === 'dateCheck' || value === 'dateStart' || value === 'dateEnd') {
                        val = data[value].split(" ")[0]
                    }
                    //else if(value === 'date' || value === 'dateAdd' || value === 'dateCheck' || value === 'dateStart' || value === 'dateEnd') {
                    //    let date = new Date(data[value]);
                    //    val = (date.getDate() < 9 ? '0' : '') + date.getDate() + '.' + (date.getMonth() < 9 ? '0' : '') + (date.getMonth() + 1) + '.' + date.getFullYear()
                    //}
                    else if(value === 'timeslot') {
                        //let date = new Date(data[value].split(" ")[0]);
                        //let time = data[value].split(" ")[1];
                        //val = <nobr>{(date.getDate() < 9 ? '0' : '') + date.getDate() + '.' + (date.getMonth() < 9 ? '0' : '') + (date.getMonth() + 1) + '.' + date.getFullYear() + " " + time}</nobr>
                        val = <nobr>{data[value]}</nobr>
                    }
                    else if(value === 'phone' || value === 'clientPhone') {
                        val = data[value] ? ('+' + data[value][0] + ' (' + 
                              data[value][1] + data[value][2] + data[value][3] + ') ' +  
                              data[value][4] + data[value][5] + data[value][6] + ' ' + 
                              data[value][7] + data[value][8] + ' ' + 
                              data[value][9] + data[value][10]) : ''
                    } 
                    else if(value === 'blacklist') {
                        val = <div className="label">{data[value] ? 'в черном списке' : 'Активный'}</div>
                    } 
                    else if(value === 'formatId') {
                        val = data[value] == 1 ? 'Онлайн' : 'Офис продаж'
                    } 
                    else if(value === 'status') {
                        val = <div className="label">{data[value]}</div>
                    }
                    else if(value === 'actions') {
                        val = actions()
                    } 
                    else if(value === 'action') {
                        //val = data['status'] === 'Запланирована' || (data['status'] === 'Выполнена' && !data['rate']) ? action() : ''
                        val = data['status'] === 'Запланирована' || data['status'] === 'Запланирован' ? action() : ''
                    }
                    else if(value === 'result') {
                        val = data[value] ? 'УНИКАЛЬНЫЙ' : 'НЕ УНИКАЛЬНЫЙ'
                    }
                    else {
                        val = data[value]
                    }
                }
                
                return (
                    <div className="table__td" key={value}>
                        <div className="table__title">{label}</div>
                        <div className={value !== 'action' && value !== 'actions' ? "table__text" : ""}>{val}</div>
                    </div>
                );
            })}
            <div className="table__arrow" onClick={() => setOpen(!open)}/>
        </div>
    )
}

export default TableRowMob